import React from 'react';
import { CardsSlider } from "../../../../components/CardsSlider";
import { SectionHead } from '../../../../components/SectionHead/SectionHead';
import './CardsBrowse.scss';

export function CardsBrowse({
  isShowDate,
  isShowWatchLater,
  type,
  browseItem,
  counter = true,
  limit = 20,
  onToggleWatchLater,
  onSeeAll
}) {
  const { title, data } = browseItem;

  if(!data) {
    return null;
  }

  const dataSize = data.length;

  if(!dataSize) {
    return null;
  }

  function handleSeeAll() {
    // actid=11
    const url = title === 'Watch List' 
      ? '/classes/watch-later/' 
      : title === 'Continue Watching' 
        ? `/${type}/` + browseItem.slug 
        : `/${type}/browse/` + browseItem.slug;

    window.analytics?.track("button:click", {
      "button_name": "See all",
      "parent_object_title": title,
      "url": url
    });
    onSeeAll(browseItem);
  }

  return (
    <div className="CardsBrowse">
      <SectionHead
        title={title}
        count={counter ? dataSize : false}
        action={{
          type: 'button',
          children: 'See all',
          arrow: 'right',
          onClick: handleSeeAll
        }}
      />

      <CardsSlider
        title={title}
        addPopupSeriesSearchParam
        isShowDate={isShowDate}
        isShowWatchLater={isShowWatchLater}
        type={type}
        cards={data}
        limit={limit}
        onToggleWatchLater={onToggleWatchLater}
        onSeeAll={handleSeeAll}
      />
    </div>
  );
}
